import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FETCH_PROFCOUNTRY_ACTION,
  FETCH_PROFCOUNTRY_SUCCESS_ACTION,
  FETCH_PROFCOUNTRY_FAIL_ACTION,
  FETCH_REGION_ACTION,
  FETCH_REGION_SUCCESS_ACTION,
  FETCH_REGION_FAIL_ACTION,
  FETCH_LOCATION_ACTION,
  FETCH_LOCATION_SUCCESS_ACTION,
  FETCH_LOCATION_FAIL_ACTION,
  FETCH_OPEQUIPMENT_ACTION,
  FETCH_OPEQUIPMENT_SUCCESS_ACTION,
  FETCH_OPEQUIPMENT_FAIL_ACTION,
  FETCH_CARGOTYPE_ACTION,
  FETCH_CARGOTYPE_SUCCESS_ACTION,
  FETCH_CARGOTYPE_FAIL_ACTION,
  ADD_DRIVERPROFILE_ACTION,
  ADD_DRIVERPROFILE_FAIL_ACTION,
  ADD_DRIVERPROFILE_SUCCESS_ACTION,
  CREATE_DRIVERPROFILE_ACTION,
  CREATE_DRIVERPROFILE_FAIL_ACTION,
  CREATE_DRIVERPROFILE_SUCCESS_ACTION,
  FETCH_DRIVER_IMG_INIT_ACTION,
  FETCH_DRIVER_IMG_INIT_ACTION_SUCCESS_ACTION,
  FETCH_DRIVER_IMG_INIT_FAIL_ACTION,
  FETCH_DRIVER_LICENSEIMG_INIT_ACTION,
  FETCH_DRIVER_LICENSEIMG_SUCCESS_ACTION,
  FETCH_DRIVER_LICENSEIMG_FAIL_ACTION,
  FETCH_LICENSEBACKIMG_INIT_ACTION,
  FETCH_LICENSEBACKIMG_SUCCESS_ACTION,
  FETCH_LICENSEBACKIMG_FAIL_ACTION,
  FETCH_RESPERMITFRONTIMG_INIT_ACTION,
  FETCH_RESPERMITFRONTIMG_SUCCESS_ACTION,
  FETCH_RESPERMITFRONTIMG_FAIL_ACTION,
  FETCH_RESPERMITBACKIMG_INIT_ACTION,
  FETCH_RESPERMITBACKIMG_SUCCESS_ACTION,
  FETCH_RESPERMITBACKIMG_FAIL_ACTION,
  EDIT_DRIVERPROFILE_ACTION,
  EDIT_DRIVERPROFILE_FAIL_ACTION,
  EDIT_DRIVERPROFILE_SUCCESS_ACTION,
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchCountry(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/country", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_PROFCOUNTRY_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: FETCH_PROFCOUNTRY_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchregion(params) {
  let countryId = (params.params && params.params.countryId) || "";
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/region?countryId=${countryId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_REGION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: FETCH_REGION_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchlocation(params) {
  let regionId = (params.params && params.params.regionId) || null;
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(
      `${appConfig.ip}/operatingLoc?regionId=${regionId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_LOCATION_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: FETCH_LOCATION_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchopequipment(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/opEquipmnt", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_OPEQUIPMENT_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: FETCH_OPEQUIPMENT_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchcargotype(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/cargotype", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_CARGOTYPE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: FETCH_CARGOTYPE_FAIL_ACTION,
      error: err,
    });
  }
}

// function* adddriverprofile(value) {
//   console.log("$$$$$$$$$$$$$$$", value);

//   const token = localStorage.getItem("token");
//   let user = JSON.parse(localStorage.getItem("user"));

//   const driveruserValue = {
//     name: value.value.name,
//     lName: value.value.LName,
//     email: value.value.mobileNo + "@gmail.com",
//     mobileNo: value.value.mobileNo,
//     country: value.value.country,
//     password: value.value.password,
//     role: "driver",
//     callingCode: value.value.callingCode,
//     orgId: user.orgId,
//     // orgName:value.value.reqType,
//   };

//   try {
//     let res = yield fetch(appConfig.ip + "/users", {
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + token,
//       },
//       body: JSON.stringify(driveruserValue),
//     });
//     if (!res) {
//       throw res;
//     } else {
//       let resJSON = yield res.json();

//       let userId = resJSON.user.id;

//       yield put({
//         type: CREATE_DRIVERPROFILE_ACTION,
//       });
//       try {
//         let orderData = {
//           userId: userId,
//           orgId: user.orgId,
//           name: value.value.name,
//           lName: value.value.LName,
//           dateOfB: value.value.dateOfB,
//           addr2: value.value.addr2,
//           addr1: value.value.addr1,
//           geoLoc: (value.value && value.value.geo) || [],
//           nationality: value.value.nationality,
//           region: value.value.region,
//           location: value.value.location,
//           city: value.value.city,
//           zip: value.value.zip,
//           opEquipmnt: (value.value && value.value.opEquipmnt) || [],
//           cargoType: (value.value && value.value.cargoType) || [],
//           resPermitNo: value.value.resPermitNo,
//           resPermitExp: value.value.resPermitExp,
//           dlNo: value.value.dlNo,
//           dlExpDate: value.value.dlExpDate,
//           passportNo: value.value.passportNo,
//           passportExp: value.value.passportExp,
//           ftLogin: false,
//         };
//         let imageData = {
//           digital_signature: value.value && value.value.digital_signature,
//         };
//         let imagelicImg = {
//           licImg: value.value && value.value.licImg,
//         };

//         let imagelicImgBack = {
//           licImgBack: value.value && value.value.licImgBack,
//         };

//         let imageresPermitImg = {
//           resPermitImg: value.value && value.value.resPermitImg,
//         };

//         let imageresPermitBack = {
//           resPermitBack: value.value && value.value.resPermitBack,
//         };

//         console.log("images", imageData);
//         let res = yield fetch(appConfig.ip + "/dProf/dProfUpsert", {
//           method: "POST",
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + token,
//           },
//           body: JSON.stringify(orderData),
//         });
//         if (!res.ok) {
//           let errJSON = {};
//           try {
//             errJSON = yield res.json();
//           } catch {}
//           throw Object.assign(res, errJSON);
//         } else {
//           let resJSON = yield res.json();
//           yield put({
//             type: CREATE_DRIVERPROFILE_SUCCESS_ACTION,
//             payload: resJSON,
//           });
//           yield put(push("/drivers"));
//           yield toast.success("Driver Added successfully", {
//             autoClose: 3000,
//           });
//           yield put({
//             type: "FETCH_DRIVER_IMG_INIT_ACTION",
//             value: imageData,
//             userId: userId,
//           });
//           yield put({
//             type: "FETCH_DRIVER_LICENSEIMG_INIT_ACTION",
//             value: imagelicImg,
//             userId: userId,
//           });
//           yield put({
//             type: "FETCH_LICENSEBACKIMG_INIT_ACTION",
//             value: imagelicImgBack,
//             userId: userId,
//           });
//           yield put({
//             type: "FETCH_RESPERMITFRONTIMG_INIT_ACTION",
//             value: imageresPermitImg,
//             userId: userId,
//           });
//           yield put({
//             type: "FETCH_RESPERMITBACKIMG_INIT_ACTION",
//             value: imageresPermitBack,
//             userId: userId,
//           });
//         }
//       } catch (err) {
//         yield put({
//           type: CREATE_DRIVERPROFILE_FAIL_ACTION,
//           error: err,
//         });
//       }
//       yield put({
//         type: ADD_DRIVERPROFILE_SUCCESS_ACTION,
//         payload: resJSON,
//       });
//     }
//   } catch (err) {
//     yield put({
//       type: ADD_DRIVERPROFILE_FAIL_ACTION,
//       error: err,
//     });
//   }
// }

// function* addDriverImg(value) {
//   try {
//     const data = new FormData();

//     data.append(value.userId, value.value.digital_signature);

//     const token = localStorage.getItem("token");
//     const res = yield fetch(`${appConfig.ip}/users/image`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       body: data,
//     });
//     if (!res.ok) {
//       let errJSON = {};
//       try {
//         errJSON = yield res.json();
//       } catch {}
//       throw Object.assign(res, errJSON);
//     } else {
//     }
//   } catch (err) {
//     console.log("dataaaa", err);
//     if (err.ok === false) {
//       yield put({
//         type: FETCH_DRIVER_IMG_INIT_FAIL_ACTION,
//         error: err,
//       });
//     } else {
//     }
//   }
// }

// function* addDriverlicImg(value) {
//   try {
//     const data = new FormData();

//     data.append(
//       value.userId + "-licFront",
//       value.value.licImg,
//       value.value.licImg.name
//     );
//     data.append("imgType", "licImgFront");
//     data.append("userId", value.userId);

//     const token = localStorage.getItem("token");
//     const res = yield fetch(`${appConfig.ip}/dProf/licImg`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       body: data,
//     });
//     if (!res.ok) {
//       let errJSON = {};
//       yield put({
//         type: FETCH_DRIVER_LICENSEIMG_SUCCESS_ACTION,
//         payload: errJSON,
//       });
//       try {
//         errJSON = yield res.json();
//       } catch {}
//       throw Object.assign(res, errJSON);
//     } else {
//     }
//   } catch (err) {
//     console.log("dataaaa", err);
//     if (err.ok === false) {
//       yield put({
//         type: FETCH_DRIVER_LICENSEIMG_FAIL_ACTION,
//         error: err,
//       });
//     } else {
//     }
//   }
// }

// function* addDriverlicImgBack(value) {
//   try {
//     const data = new FormData();

//     data.append(
//       value.userId + "-licBack",
//       value.value.licImgBack,
//       value.value.licImgBack.name
//     );
//     data.append("imgType", "licImgBack");
//     data.append("userId", value.userId);

//     const token = localStorage.getItem("token");
//     const res = yield fetch(`${appConfig.ip}/dProf/licImg`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       body: data,
//     });
//     if (!res.ok) {
//       let errJSON = {};
//       yield put({
//         type: FETCH_LICENSEBACKIMG_SUCCESS_ACTION,
//         payload: errJSON,
//       });
//       try {
//         errJSON = yield res.json();
//       } catch {}
//       throw Object.assign(res, errJSON);
//     } else {
//     }
//   } catch (err) {
//     console.log("dataaaa", err);
//     if (err.ok === false) {
//       yield put({
//         type: FETCH_LICENSEBACKIMG_FAIL_ACTION,
//         error: err,
//       });
//     } else {
//     }
//   }
// }

// function* addresPermitImg(value) {
//   try {
//     const data = new FormData();

//     data.append(
//       value.userId + "-resPermitFront",
//       value.value.resPermitImg,
//       value.value.resPermitImg.name
//     );
//     data.append("imgType", "resPermitImgFront");
//     data.append("userId", value.userId);

//     const token = localStorage.getItem("token");
//     const res = yield fetch(`${appConfig.ip}/dProf/resPermitImg`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       body: data,
//     });
//     if (!res.ok) {
//       let errJSON = {};
//       yield put({
//         type: FETCH_RESPERMITFRONTIMG_SUCCESS_ACTION,
//         payload: errJSON,
//       });
//       try {
//         errJSON = yield res.json();
//       } catch {}
//       throw Object.assign(res, errJSON);
//     } else {
//     }
//   } catch (err) {
//     console.log("dataaaa", err);
//     if (err.ok === false) {
//       yield put({
//         type: FETCH_RESPERMITFRONTIMG_FAIL_ACTION,
//         error: err,
//       });
//     } else {
//     }
//   }
// }

// function* addresPermitBack(value) {
//   try {
//     const data = new FormData();

//     data.append(
//       value.userId + "-resPermitBack",
//       value.value.resPermitBack,
//       value.value.resPermitBack.name
//     );
//     data.append("imgType", "resPermitImgBack");
//     data.append("userId", value.userId);

//     const token = localStorage.getItem("token");
//     const res = yield fetch(`${appConfig.ip}/dProf/resPermitImg`, {
//       method: "POST",
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       body: data,
//     });
//     if (!res.ok) {
//       let errJSON = {};
//       yield put({
//         type: FETCH_RESPERMITBACKIMG_SUCCESS_ACTION,
//         payload: errJSON,
//       });
//       try {
//         errJSON = yield res.json();
//       } catch {}
//       throw Object.assign(res, errJSON);
//     } else {
//     }
//   } catch (err) {
//     console.log("dataaaa", err);
//     if (err.ok === false) {
//       yield put({
//         type: FETCH_RESPERMITBACKIMG_FAIL_ACTION,
//         error: err,
//       });
//     } else {
//     }
//   }
// }
// ================================================================

// function* editdriverprofile(value) {
//   console.log("$$$$$$$$$$$$$$$EDITTTTTT", value);

//   const token = localStorage.getItem("token");
//   let user = JSON.parse(localStorage.getItem("user"));
//   let id = value.value.id;
//   console.log("+++++++++++++++++++++", id);
//   const driveruserValue = {
//     name: value.value.name,
//     lName: value.value.LName,

//     country: value.value.country,
//     password: value.value.password,
//     role: "driver",
//     callingCode: value.value.callingCode,
//     orgId: user.orgId,
//   };

//   try {
//     let res = yield fetch(appConfig.ip + "/users/"+id, {
//       method: "PUT",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + token,
//       },
//       body: JSON.stringify(driveruserValue),
//     });
//     if (!res) {
//       throw res;
//     } else {
//       let resJSON = yield res.json();
//       let userId = resJSON.user.id;
//       yield put({
//         type: CREATE_DRIVERPROFILE_ACTION,
//       });
//       try {
//         let orderData = {
//           userId: userId,
//           orgId: user.orgId,
//           name: value.value.name,
//           lName: value.value.LName,
//           dateOfB: value.value.dateOfB,
//           addr2: value.value.addr2,
//           addr1: value.value.addr1,
//           geoLoc: (value.value && value.value.geo) || [],
//           nationality: value.value.nationality,
//           region: value.value.region,
//           location: value.value.location,
//           city: value.value.city,
//           zip: value.value.zip,
//           opEquipmnt: (value.value && value.value.opEquipmnt) || [],
//           cargoType: (value.value && value.value.cargoType) || [],
//           resPermitNo: value.value.resPermitNo,
//           resPermitExp: value.value.resPermitExp,
//           dlNo: value.value.dlNo,
//           dlExpDate: value.value.dlExpDate,
//           passportNo: value.value.passportNo,
//           passportExp: value.value.passportExp,
//           ftLogin: false,
//         };
//         let res = yield fetch(appConfig.ip + "/dProf/dProfUpsert/", {
//           method: "P",
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: "Bearer " + token,
//           },
//           body: JSON.stringify(orderData),
//         });
//         if (!res.ok) {
//           let errJSON = {};
//           try {
//             errJSON = yield res.json();
//           } catch {}
//           throw Object.assign(res, errJSON);
//         } else {
//           let resJSON = yield res.json();
//           yield put({
//             type: CREATE_DRIVERPROFILE_SUCCESS_ACTION,
//             payload: resJSON,
//           });
//           yield put(push("/drivers"));
//           yield toast.success("Driver updated successfully", {
//             autoClose: 3000,
//           });
//         }
//       } catch (err) {
//         yield put({
//           type: CREATE_DRIVERPROFILE_FAIL_ACTION,
//           error: err,
//         });
//       }
//       yield put({
//         type: EDIT_DRIVERPROFILE_SUCCESS_ACTION,
//         payload: resJSON,
//       });
//     }
//   } catch (err) {
//     yield put({
//       type: EDIT_DRIVERPROFILE_FAIL_ACTION,
//       error: err,
//     });
//   }
// }

// function* editdriverprofile(value) {
//   console.log("value===========", value);

//   const token = localStorage.getItem("token");
//   let user = JSON.parse(localStorage.getItem("user"));
//   const driverData = {
//     userId: value.value.userId,
//     orgId: user.orgId,
//     name: value.value.name,
//     lName: value.value.LName,
//     dateOfB: value.value.dateOfB,
//     addr1: value.value.addr1,
//     addr2: value.value.addr2,
//     geoLoc: value.value.geoLoc,
//     nationality: value.value.nationality,
//     cntryOfRes: value.value.cntryOfRes,
//     region: value.value.region,
//     location: value.value.location,
//     city: value.value.city,
//     zip: value.value.zip,
//     resPermitNo: value.value.resPermitNo,
//     resPermitExp: value.value.resPermitExp,
//     dlNo: value.value.dlNo,
//     dlExpDate: value.value.dlExpDate,
//     passportNo: value.value.passportNo,
//     passportExp: value.value.passportExp,
//     // opEquipmnt: opArr,
//     // cargoType: cargoArr,

//     ftLogin: false,
//   };
//   console.log("driverData===========", driverData);
//   try {
//     const res = yield fetch(`${appConfig.ip}/dProf/dProfUpsert/`, {
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       body: JSON.stringify(driverData),
//     });

//     if (!res.ok) {
//       let errJSON = {};
//       try {
//         errJSON = yield res.json();
//       } catch {
//         throw Object.assign(res, errJSON);
//       }
//     } else {
//       const resJSON = yield res.json();
//       console.log("resJSON####resJSON#####resJSON", resJSON);
//       yield put({
//         type: EDIT_DRIVERPROFILE_SUCCESS_ACTION,
//       });
//       yield put(push("/drivers"));
//       yield toast.success("Driver updated successfully", {
//         autoClose: 3000,
//       });
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({
//         type: EDIT_DRIVERPROFILE_FAIL_ACTION,
//         error: err,
//       });
//     }
//   }
// }

export function* AddNewDriverActionWatcher() {
  yield takeEvery(FETCH_PROFCOUNTRY_ACTION, fetchCountry);
  yield takeEvery(FETCH_REGION_ACTION, fetchregion);
  yield takeEvery(FETCH_LOCATION_ACTION, fetchlocation);
  yield takeEvery(FETCH_OPEQUIPMENT_ACTION, fetchopequipment);
  yield takeEvery(FETCH_CARGOTYPE_ACTION, fetchcargotype);
  // yield takeEvery(ADD_DRIVERPROFILE_ACTION, adddriverprofile);
  // yield takeEvery(FETCH_DRIVER_IMG_INIT_ACTION, addDriverImg);
  // yield takeEvery(FETCH_DRIVER_LICENSEIMG_INIT_ACTION, addDriverlicImg);
  // yield takeEvery(FETCH_LICENSEBACKIMG_INIT_ACTION, addDriverlicImgBack);
  // yield takeEvery(FETCH_RESPERMITFRONTIMG_INIT_ACTION, addresPermitImg);
  // yield takeEvery(FETCH_RESPERMITBACKIMG_INIT_ACTION, addresPermitBack);

  // yield takeEvery(EDIT_DRIVERPROFILE_ACTION, editdriverprofile);
}
